import React, { useState } from "react"; 
import Narrow from '../img/dark-narrow.svg';

function Sorting({sortOrder=[],fetchData,categoryId}) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
   
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const handleSortOptionClick = (order) => {
        const nextPage = 0;
        if (fetchData) {
            fetchData(categoryId,nextPage,order); 
        }
        setIsDropdownOpen(false);
    };
    
    const currentSort = sortOrder?.find((option) => option.current);
 
    return(
       <div className="sort-product">
           
            <div className="dropdown">

                <button onClick={toggleDropdown}>
                    {currentSort ? currentSort.label : "پیش فرض"}
                  
                </button>
                <span>
                    <img src={Narrow}/>
                </span>
                {isDropdownOpen && (
                <ul className="dropdown-menu show">
                    {sortOrder.map((sort) => (
                        <li onClick={() => handleSortOptionClick(sort.urlParameter)}>{sort.label}</li>
                    ))}
                </ul>
                )}
            </div>
       </div>
    );

}

export default Sorting;